import React from 'react';
import SelectStudent from '.';
import { useSearchStudentsHandler, useValidateTransferDetails } from '../../customHooks';
import { getColumnList } from './tableColumnConfig';
import FilterForm from './listingTopFilter/FilterForm';
import { searchStudents } from '../searchStudent/constants';
import SelectStudentFooter from './SelectStudentFooter';

const SelectStudentWrapper = () => {
    const { searchHandler } = useSearchStudentsHandler();
    const { validate } = useValidateTransferDetails();

    const handleSearch = (...args) => searchHandler(...args, searchStudents);

    return (
        <>
            <SelectStudent
                searchHandler={handleSearch}
                validate={validate}
                getColumnList={getColumnList}
                FilterForm={FilterForm}
            />

            <SelectStudentFooter
                validate={validate}
            />

        </>
    );
}

export default SelectStudentWrapper;